// language=GraphQL
export const ALL_ELEMENT_SEO_SETTINGS_QUERY = `query Query($withOgImage: Boolean = false) {
  elementSeoSettings: allElementSeoSettings {
    id
    urlSlug
    metaTitle
    metaDescription
    ogTitle
    ogDescription
    ogImage @include(if: $withOgImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_ELEMENT_SEO_SETTINGS_QUERY = `query Query($id: ID!, $withOgImage: Boolean = false) {
  elementSeoSettings: elementSeoSettings(id: $id) {
    id
    urlSlug
    metaTitle
    metaDescription
    ogTitle
    ogDescription
    ogImage @include(if: $withOgImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_ELEMENT_SEO_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateElementSeoSettingsInput, $withOgImage: Boolean = false) {
    elementSeoSettings: createElementSeoSettings(input: $input) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_ELEMENT_SEO_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateElementSeoSettingsInput, $withOgImage: Boolean = false) {
    elementSeoSettings: updateElementSeoSettings(input: $input) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_ELEMENT_SEO_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteElementSeoSettingsInput) {
    deleteElementSeoSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteElementSeoSettingsInput) {
    forceDeleteElementSeoSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ELEMENT_SEO_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsPages: Boolean = false, $withCmsCategories: Boolean = false, $withTravels: Boolean = false) {
  groupedDependents: elementSeoSettingsDependents(id: $id) {
    cmsPages @include(if: $withCmsPages) {
      id
      name
      onlineStatus
    }
    cmsCategories @include(if: $withCmsCategories) {
      id
      name
    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
  }
}`
